import { useEffect, useRef } from 'react';
/*
 * @see https://github.com/reactwg/react-18/discussions/18#discussion-3385714
 */
const useEffectOnce = (effect, condition = true) => {
    const ref = useRef(false);
    useEffect(() => {
        if (!ref.current && condition) {
            ref.current = true;
            return effect();
        }
        return undefined;
    }, [effect, condition]);
};
export default useEffectOnce;
